<section class="content-section overview-section">
  <div class="section-header">
    <div>
      <h2>{{ 'organizationAdmin.overview.title' | transloco }}</h2>
    </div>
  </div>

  <div class="overview-grid">
    @for (tile of displayTiles(); track $index) {
      <mat-expansion-panel
        class="overview-tile mat-elevation-z0"
        [class.tone-warning]="tile.tone === 'warning'"
        hideToggle
        [disabled]="isLoading() || tile.details.length === 0"
        [expanded]="isTileExpanded($index)"
        (opened)="setTileExpanded($index, true)"
        (closed)="setTileExpanded($index, false)">
        <mat-expansion-panel-header class="overview-tile-header" collapsedHeight="auto" expandedHeight="auto">
          <div class="tile-header-content">
            <div class="tile-header-row">
              <mat-icon class="tile-icon">{{ tile.icon }}</mat-icon>
              <span class="tile-label"><ng-container *appSingleBlocSkeleton="isLoading(); width: '60%'">{{ tile.labelKey | transloco }}</ng-container></span>
              @if (!isLoading() && tile.details.length > 0) {
                <mat-icon class="tile-chevron">{{ isTileExpanded($index) ? 'expand_less' : 'expand_more' }}</mat-icon>
              }
            </div>

            <div class="tile-value-row">
              <span class="tile-value">
                <ng-container *appSingleBlocSkeleton="isLoading(); width: '40%'">{{ tile.valueText }}</ng-container>
              </span>
              @if (tile.suffixKey || tile.suffixText) {
                <span class="tile-suffix">{{ tile.suffixKey ? (tile.suffixKey | transloco) : tile.suffixText }}</span>
              }
            </div>

            @if (tile.progress !== undefined) {
              <div class="tile-progress">
                <div class="tile-progress-fill" [style.width.%]="tile.progress"></div>
              </div>
            }
          </div>
        </mat-expansion-panel-header>

        <div class="tile-details">
          @for (detail of tile.details; track detail.labelKey) {
            <div class="tile-detail-row">
              <span class="detail-label" [class.warn]="detail.warn">{{ detail.labelKey | transloco }}</span>
              @if (detail.value) {
                <span class="detail-value" [class.warn]="detail.warn">{{ detail.value }}</span>
              }
            </div>
          }
        </div>
      </mat-expansion-panel>
    }
  </div>
</section>

@if (canAdministrate) {
  <section class="content-section">
    @if (!isLoading()) {
      <app-company-data
        [organizationInput]="organization()"
        [allCountriesInput]="allCountries()"
        [docProfilesInput]="docProfiles()"
        (saved)="onCompanyDataSaved()"></app-company-data>
    }
  </section>

  <section class="content-section">
    @if (!isLoading()) {
      <app-ppwr-roles [organizationInput]="organization()" [allCountriesInput]="allCountries()" [docProfilesInput]="docProfiles()"></app-ppwr-roles>
    }
  </section>

  @if (!isLoading()) {
    <app-connected-organizations [organizationName]="organization().name"></app-connected-organizations>
  }
}
